import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo.png";

import BienvenidoDiseno from "../../components/Diseño/BienvenidoDiseno";
import TituloPagina from "../../components/comunes/TituloPagina";
import NotificacionesContenido from "../../components/administracion/NotificacionesContenido";
import Footer from "../../components/comunes/Footer";
import { getToken } from "../../utils/auth";


const DisenoNotificaciones = () => {
    const apiUrlToken = process.env.REACT_APP_API_TOKEN;
    const apiUrlNotificaciones = process.env.REACT_APP_API_NOTIFICACIONES;

    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();

    const [validandoToken, setValidandoToken] = useState(true);
    const [autorizado, setAutorizado] = useState(false);
    const [cargandoNotificaciones, setCargandoNotificaciones] = useState(false);

    const [notificacionesAliados, setNotificacionesAliados] = useState([]);
    const [notificacionesAsesores, setNotificacionesAsesores] = useState([]);

    useEffect(() => {
        let cancelado = false;

        const redireccionar = () => {
            if (!cancelado) {
                navegacion("/", { replace: true });
            }
        };

        const alertNoAutorizado = async () => {
            sessionStorage.removeItem("token");

            await Swal.fire({
                title: "Sesion expirada o token invalido.",
                text: "Inicie sesion nuevamente.",
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            });

            redireccionar();
        };

        const alertSinPermiso = async () => {
            await Swal.fire({
                title: "Acceso denegado.",
                text: "No tiene permisos para este panel.",
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            });

            redireccionar();
        };

        const verificarToken = async () => {
            const token = getToken();

            if (!token) {
                await alertNoAutorizado();
                if (!cancelado) setValidandoToken(false);
                return;
            }

            try {
                const response = await fetch(apiUrlToken, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ Token: token }),
                });

                if (response.status === 401 || response.status === 403) {
                    await alertNoAutorizado();
                    return;
                }

                if (!response.ok) {
                    throw new Error(`Error token ${response.status}`);
                }

                const raw = await response.text();
                let rol = Number(raw);

                if (!Number.isFinite(rol)) {
                    try {
                        rol = Number(JSON.parse(raw));
                    } catch {
                        rol = NaN;
                    }
                }

                if (!Number.isFinite(rol)) {
                    throw new Error("Respuesta de rol invalida");
                }

                if (rol !== 10) {
                    await alertSinPermiso();
                    return;
                }

                if (!cancelado) {
                    setAutorizado(true);
                }
            } catch (error) {
                console.error("Error al validar token", error);
                if (!cancelado) {
                    await Swal.fire({
                        title: "Error",
                        text: "No se pudo validar la sesion en este momento.",
                        icon: "error",
                        confirmButtonText: "Ok",
                        customClass: {
                            container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                            confirmButton: "my-swal-button",
                        },
                    });
                }
            } finally {
                if (!cancelado) {
                    setValidandoToken(false);
                }
            }
        };

        verificarToken();

        return () => {
            cancelado = true;
        };
    }, [apiUrlToken, darkMode, navegacion]);

    useEffect(() => {
        if (!autorizado) return;

        let cancelado = false;

        const fetchNoticias = async () => {
            try {
                setCargandoNotificaciones(true);

                const response = await fetch(apiUrlNotificaciones);
                if (!response.ok) {
                    throw new Error("No se pudieron obtener notificaciones");
                }

                const data = await response.json();
                const lista = Array.isArray(data) ? data : [];

                const noticiasAliados = lista.filter(
                    (notificacion) => (notificacion.tipoUsuario || "").trim() === "Aliado"
                );
                const noticiasAsesores = lista.filter(
                    (notificacion) => (notificacion.tipoUsuario || "").trim() === "Asesor"
                );

                if (!cancelado) {
                    setNotificacionesAliados(noticiasAliados);
                    setNotificacionesAsesores(noticiasAsesores);
                }
            } catch (error) {
            } finally {
                if (!cancelado) {
                    setCargandoNotificaciones(false);
                }
            }
        };

        fetchNoticias();

        return () => {
            cancelado = true;
        };
    }, [apiUrlNotificaciones, autorizado]);

    if (validandoToken) {
        return (
            <div className="d-flex flex-column min-vh-100" translate="no">
                <div className="pt-5">
                    <BienvenidoDiseno />

                </div>
                <div>
                    <TituloPagina title="Diseno - Notificaciones" />
                </div>
                <div className="d-flex justify-content-center align-items-center flex-grow-1">
                    <h6 className="lato-bold fs-16 mb-0">Validando sesion...</h6>
                </div>
                <div className="py-4 mt-auto">
                    <Footer />
                </div>
            </div>
        );
    }

    if (!autorizado) return null;

    return (
        <div className="d-flex flex-column min-vh-100" translate="no">
            <div className="pt-5">
                <BienvenidoDiseno />

            </div>

            <div>
                <TituloPagina title="Diseno - Notificaciones" />
            </div>

            <div>
                {cargandoNotificaciones && (
                    <div className="d-flex justify-content-center mt-2">
                        <h6 className="lato-bold fs-16 mb-0">Cargando notificaciones...</h6>
                    </div>
                )}

                <NotificacionesContenido
                    notificacionesAliados={notificacionesAliados}
                    notificacionesAsesores={notificacionesAsesores}
                />
            </div>

            <div className="py-4 mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default DisenoNotificaciones;
